import React from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'
import { venture } from '../../../config'
import loadable from '@loadable/component'
import PageTemplate from '../../templates/PageTemplate'
import Footer from '../../../containers/Footer/index'
import ComponentSelector from '../../ComponentSelector'

import { Helmet } from 'react-helmet'
const DynamicHeader = loadable(() =>
  import('@albatross/common-components/dist/components/DynamicHeader')
)
const notFoundStyle = {
  minHeight: '300px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#777777'
}

const NotFound = (props) => {
  const { location, globalComponents, globalContent, components, ConfigContxt, enableContentful } = props
  const { pathname } = location
  const hasSubNav = !!components.filter(component => component.type === 'NavigationMenu' || component.type === 'UnicornNavigationMenu').length
  return (
    <Route
      render={(props) => {
        if (props.staticContext) {
          props.staticContext.status = 404
        }
        return (
          <PageTemplate components={components} globalContent={globalContent}>
            <DynamicHeader
              venture={venture}
              globalConfig={
                globalComponents?.components?.DynamicHeader?.globalConfig
              }
              categories={globalContent.menuItems}
              hasSubNav={hasSubNav}
              appLink={globalContent.appLinks}
            />
            <Helmet>
              <title>404</title>
            </Helmet>
            {components
              ? (
              <ComponentSelector
                {...{ components, globalContent, globalComponents, ConfigContxt, enableContentful }}
              />
                )
              : (
              <div style={notFoundStyle}>
                <h2> {`${pathname} : Not Found`}</h2>
              </div>
                )}
            <Footer enableContentful={enableContentful} venture={venture} lang={globalContent.lang} />
          </PageTemplate>
        )
      }}
    />
  )
}

NotFound.propTypes = {
  location: PropTypes.object,
  globalComponents: PropTypes.object,
  staticContext: PropTypes.object,
  ConfigContxt: PropTypes.object,
  globalContent: PropTypes.object,
  components: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      props: PropTypes.object
    })
  ),
  enableContentful: PropTypes.bool
}

export default withRouter(NotFound)
